















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import { PortalLayout } from '@/layouts/portal';
import LoginDve from './components/login2.vue';
import Login from './components/login.vue';

// eslint-disable-next-line no-var
var _hmt = _hmt || [];
(function() {
  let hm = document.createElement('script');
  hm.src = 'https://hm.baidu.com/hm.js?14ec080793ad1e50a4d53e9d6d3a753e';
  let s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
})();

/** 首页 */
@Component({ components: { PortalLayout, Login, LoginDve } })
export default class Index extends Vue {
  containerStyle: any = {
    background: 'url(' + require('@/images/注册背景@2x.png') + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };

  get loginComponent() {
    return process.env.NODE_ENV === 'development' ? 'LoginDve' : 'Login';
  }
  mounted() {}
}
